<template>
  <Modal
    :visible="show"
    :lockScroll="false"
    :title="'Add to wishlists'"
    :gridCols="gridCols"
    :noBottomPadding="true"
    :clickOutside="true"
    @close="show = false"
  >
  <div class="grid wishlist-modal p-b-18">
      <WishlistController
        :model="model"
        :currentVariant="currentVariant"
        :sizes="sizes"
        :startSizeIndex="sizeIndex"
        :outlet="outlet"
        :isMoveFromShoppingBag="isMoveFromShoppingBag"
        @on-saved="show = false"
      />
  </div>
  </Modal>
</template>
<script>
import { eventBus } from '@/Scripts/lib/helper/eventBus.js';
import WishlistController from '@/Scripts/components/layout/Header/Assets/WishlistCOntroller.vue';
import Modal from '@/Scripts/components/shared/Modal/ModalNew.vue';
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';

export default {
  mixins: [siteInfo],
  components: {
    Modal,
    WishlistController
  },
  data () {
    return {
      show: false,
      model: null,
      currentVariant: null,
      sizes: null,
      sizeIndex: -1,
      outlet: false,
      isMoveFromShoppingBag: false
    };
  },
  computed: {
    gridCols () {
      return this.$mqAliases.sm || this.$mqAliases.xs ? 12 : this.$mqAliases.md || this.$mqAliases.lg ? 6 : 4;
    }
  },
  created () {
    eventBus.$on('WISHLIST_ADD', ({
      productModel = null,
      colorModel = null,
      sizeIndex = -1,
      sizes = null,
      outlet = false,
      isMoveFromShoppingBag = null
    }) => {
      // map data
      this.model = productModel;
      this.currentVariant = colorModel;
      this.sizes = sizes;
      this.sizeIndex = sizeIndex;
      this.outlet = outlet;
      this.isMoveFromShoppingBag = isMoveFromShoppingBag;
      this.show = true;
    });
  }
};
</script>
<style lang="scss">
@import "@/scss/defaults.scss";
.wishlist-modal {
  .-disabled {
    pointer-events: none;
    color: $gray-light;
  }
}
</style>
